module.exports = __webpack_public_path__ + "media/sk_sk_s2_Ladislava.a3ae2d58.oga";